export default "__VITE_ASSET__VvUAqrqm__"